var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSticker2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 53.1 49",
    style: {
      enableBackground: "new 0 0 53.1 49"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#000000;stroke-width:0.5;stroke-miterlimit:10;}\n\t.st1{fill:none;stroke:#000000;stroke-miterlimit:10;}\n\t.st2{fill:none;stroke:#858589;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st3{fill:none;stroke:#E2DEDE;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st4{fill:#FA9A63;}\n\t.st5{fill:#FADC63;}\n\t.st6{fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\n\t.st7{fill:url(#);stroke:#000000;stroke-miterlimit:10;}\n\t.st8{fill:none;stroke:#FFFFFF;stroke-width:2;stroke-miterlimit:10;}\n\t.st9{fill:#FFFFFF;}\n\t.st10{fill:none;stroke:#FFFFFF;stroke-width:0.5;stroke-miterlimit:10;}\n\t.st11{fill:none;stroke:#FFFFFF;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M39.1,23.2c0.6-1.5,0.9-3.2,0.9-4.9C40,10.7,33.9,1,26.3,1c-7.6,0-13.7,9.7-13.7,17.3c0,1.7,0.3,3.4,0.9,4.9 c-5.4,2.5-8.9,6.5-8.9,11.1c0,7.6,9.7,13.7,21.7,13.7c12,0,21.7-6.1,21.7-13.7C48,29.7,44.5,25.7,39.1,23.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2,48c0-3.4,2.7-6.1,6.1-6.1s6.1,2.7,6.1,6.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37.2,15.8c0,1.5-2,2.7-4.5,2.7s-4.5-1.2-4.5-2.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6,13.6c0-2.5,2-4.5,4.5-4.5s4.5,2,4.5,4.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M26.8,14c0-3.4,2.7-6.1,6.1-6.1S39,10.6,39,14"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.1,
    cy: 15.2,
    r: 2.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24,15.8c0,1.5-2,2.7-4.5,2.7S15,17.3,15,15.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4,13.6c0-2.5,2-4.5,4.5-4.5s4.5,2,4.5,4.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M13.6,14c0-3.4,2.7-6.1,6.1-6.1s6.1,2.7,6.1,6.1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.8,
    cy: 15.2,
    r: 2.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9,16.6c-1,1.4-10.7-6-16.5-10s-5.5-3.3-4.5-4.6s6.6-0.6,12.4,3.4S53.9,15.2,52.9,16.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.2,16.6c1,1.4,10.7-6,16.5-10s5.5-3.3,4.5-4.6S14.6,1.3,8.7,5.4S-0.8,15.2,0.2,16.6z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSticker2);
export default __webpack_public_path__ + "static/media/sticker_2.4cac577d7d304b0a56da59d5e732a8bc.svg";
export { ForwardRef as ReactComponent };